import { createClient, SupabaseClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase Environment Variables');
}

let supabaseInstance: SupabaseClient | null = null;

export const getSupabase = (): SupabaseClient => {
  if (!supabaseInstance) {
    supabaseInstance = createClient(supabaseUrl, supabaseAnonKey, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
        storageKey: 'nutribot-auth-token',
        // Optimize token refresh behavior
        flowType: 'pkce',
        // Only refresh when token is about to expire (default is 60 seconds before)
        // This prevents frequent refreshes
      },
      global: {
        headers: {
          'x-application-name': 'nutribot'
        }
      },
      // Reduce realtime reconnection attempts that might trigger token refreshes
      realtime: {
        params: {
          eventsPerSecond: 2
        }
      }
    });

    // Log token refresh events for debugging
    supabaseInstance.auth.onAuthStateChange((event, session) => {
      if (event === 'TOKEN_REFRESHED') {
        // console.log('[Supabase] Token refreshed at:', new Date().toISOString());
      } else if (event === 'SIGNED_OUT') {
        // console.log('[Supabase] User signed out');
      }
    });
  }
  
  return supabaseInstance;
};

export const supabase = getSupabase();